<script>
export default {
    props: {
        accommodationSiteId: {
            type: Number,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        },
        siteId: {
            type: Number,
            required: true,
        },
        status: {
            type: String,
            required: true
        },
        from: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            toggled: false
        }
    },
    methods: {
        add(obj) {
            this.$emit('add', obj)
        }
    }
}
</script>
<template>
    <div :class="{'dashboard-notifications-item__control--toggled': toggled}" class="dashboard-notifications-item">
        <div class="dashboard-notifications-item__header">
            <div class="dashboard-notifications-item__label">
                {{ accommodation }} > {{ site }}
            </div>
            <div class="dashboard-notifications-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
            <div class="dashboard-notifications-item__control" @click="add({
                siteId: siteId,
                accommodationSiteId: accommodationSiteId,
                from: from,
                to: to
            })">
                <i class="fa fa-plus"/>
            </div>
        </div>
        <transition name="dashboard-notifications-item__content-animation">
            <div v-if="toggled" class="dashboard-notifications-item__content">
                <div class="dashboard-notifications-item__props">
                    <div class="dashboard-notifications-item__prop">
                        <div class="dashboard-notifications-item__prop-key">
                            {{ $t('dashboard.notifications.list.site') }}
                        </div>
                        <div class="dashboard-notifications-item__prop-value">
                            {{ site }}
                        </div>
                    </div>
                    <div class="dashboard-notifications-item__prop">
                        <div class="dashboard-notifications-item__prop-key">
                            {{ $t('dashboard.notifications.list.status.label') }}
                        </div>
                        <div class="dashboard-notifications-item__prop-value">
                            {{ $t('dashboard.notifications.list.status.' + status) }}
                        </div>
                    </div>
                    <div class="dashboard-notifications-item__prop">
                        <div class="dashboard-notifications-item__prop-key">
                            {{ $t('dashboard.notifications.list.date') }}
                        </div>
                        <div class="dashboard-notifications-item__prop-value">
                            {{ from | moment("DD/MM/YYYY") }} - {{ to | moment("DD/MM/YYYY") }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardNotificationsItem/DashboardNotificationsItem.vue